import React from "react";
import colors from "theme/config/colors";
import Button, { Theme } from "theme/components/buttons/Button";

const DarkGreenSolidButton = (props: any) => {
    const theme: Theme = {
        color: colors.white,
        backgroundColor: colors.darkGreen,
        hover: {
            color: colors.darkGreen,
            backgroundColor: "transparent",
            borderColor: colors.darkGreen,
        },
        disabled: {
            opacity: "30%",
        },
    };

    return <Button {...props} theme={theme} />;
};

export default DarkGreenSolidButton;
